export const TRUNCATE_ELLIPSIS = '…';
export const TRUNCATE_TYPE = {
  auto: 'auto',
  start: 'start',
  middle: 'middle',
  end: 'end',
  none: 'none',
};

export const TRUNCATE_DEFAULT_PROPS = {
  ellipsis: TRUNCATE_ELLIPSIS,
  truncationPosition: TRUNCATE_TYPE.auto,
  limit: 0,
  numberOfLines: 0,
};

/**
 * Modified from source.
 * @see https://github.com/kahwee/truncate-middle
 */
export const truncateMiddle = (
  content: string,
  startLength: number,
  endLength: number,
  ellipsis?: string
) => {
  const contentLength = content.length;
  // Setting default values
  const frontLength = ~~startLength; // will cast to integer
  const backLength = ~~endLength;
  const truncateStr = ellipsis || TRUNCATE_ELLIPSIS;

  if (
    (frontLength === 0 && backLength === 0) ||
    frontLength >= contentLength ||
    backLength >= contentLength ||
    frontLength + backLength >= contentLength
  ) {
    return {
      content,
      didCustomTruncate: false,
    };
  } else if (backLength === 0) {
    return {
      content: content.slice(0, frontLength) + truncateStr,
      didCustomTruncate: true,
    };
  } else {
    return {
      content:
        content.slice(0, frontLength) +
        truncateStr +
        content.slice(contentLength - backLength),
      didCustomTruncate: true,
    };
  }
};

export const truncateContent = (
  content = '',
  props: Partial<typeof TRUNCATE_DEFAULT_PROPS>
) => {
  const mergedProps = {...TRUNCATE_DEFAULT_PROPS, ...props};
  const {ellipsis, truncationPosition, limit} = mergedProps;

  if (truncationPosition === TRUNCATE_TYPE.none) {
    return {
      content,
      didCustomTruncate: false,
    };
  }

  let truncateStart;
  let truncateEnd;

  switch (truncationPosition) {
    case TRUNCATE_TYPE.start:
      truncateStart = 0;
      truncateEnd = limit;
      break;
    case TRUNCATE_TYPE.middle:
      truncateStart = Math.floor(limit / 2);
      truncateEnd = Math.floor(limit / 2);
      break;
    default:
      truncateStart = limit;
      truncateEnd = 0;
  }

  const truncatedContent =
    truncationPosition !== TRUNCATE_TYPE.auto
      ? truncateMiddle(content, truncateStart, truncateEnd, ellipsis)
      : {
          content,
          didCustomTruncate: false,
        };

  return truncatedContent;
};
